import { Injectable, signal } from '@angular/core';

function getInitialDarkMode(): boolean {
  const savedTheme = localStorage.getItem('fury-theme');
  if (savedTheme) {
    return savedTheme === 'dark';
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/** Toggles the `.dark` class on `<html>` and persists the preference. */
@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  readonly isDarkMode = signal<boolean>(getInitialDarkMode());

  constructor() {
    this.applyTheme(this.isDarkMode());
  }

  toggleTheme(): void {
    this.isDarkMode.update(value => !value);
    this.applyTheme(this.isDarkMode());
  }

  private applyTheme(isDark: boolean): void {
    document.documentElement.classList.toggle('dark', isDark);
    localStorage.setItem('fury-theme', isDark ? 'dark' : 'light');
  }
}
